import {
  ROLES,
  type RoleStrategy,
  api,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useServicesShortcutsApi = () => {
  const { queryKey, endpoint } = useRoleConf(apiRoleConf())

  const { data: shortcuts = [], isLoading } = useQuery({
    queryKey,
    queryFn: () => api.get<ApiShortcuts>(endpoint),
    select: (raw) => raw.shortcuts ?? [],
  })

  return {
    shortcuts,
    isLoading,
  }
}

export interface ApiShortcuts {
  shortcuts: Shortcut[]
}

interface Shortcut {
  logo: Logo
  name: string
  website: string
}

interface Logo {
  tempFileId: string
  contentType: string
  originalFileName: string
}

interface Conf {
  queryKey: string[]
  endpoint: string
}

const adhRoleConf: Conf = {
  queryKey: ["solutions", "adherent", "shortcuts"],
  endpoint: "/api/solutions/adherent/shortcuts",
}

const apiRoleConf = (): RoleStrategy<Conf> => ({
  [ROLES.ADHERENT_HOLDER]: adhRoleConf,
  [ROLES.ADHERENT_TEAM]: adhRoleConf,
})
